import React from 'react';
import { ApplicantStatus } from '../../types/enums.js';

interface StatusUpdateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpdate: (newStatus: ApplicantStatus) => void;
  currentStatus: ApplicantStatus;
}

const formatStatusName = (status: ApplicantStatus): string => {
  return String(status).replace(/_/g, ' ');
};

export function StatusUpdateModal({ isOpen, onClose, onUpdate, currentStatus }: StatusUpdateModalProps) {
  if (!isOpen) return null;

  const colors = {
    [ApplicantStatus.APPLIED]: 'bg-gray-400',
    [ApplicantStatus.SAMPLE_REQUESTED]: 'bg-yellow-400',
    [ApplicantStatus.OFFER_SENT]: 'bg-blue-400',
    [ApplicantStatus.REJECTED]: 'bg-red-400',
    [ApplicantStatus.IN_REVIEW]: 'bg-purple-400'
  };

  // Filter out numeric values
  const statuses = Object.values(ApplicantStatus).filter(status => 
    isNaN(Number(status))
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-800 rounded-lg p-6 w-96">
        <h2 className="text-xl font-semibold text-gray-100 mb-4">Update Status</h2>
        
        <div className="space-y-2">
          {statuses.map((status) => (
            <button
              key={status}
              onClick={() => {
                onUpdate(status);
                onClose();
              }}
              className={`w-full p-2 rounded-lg text-left ${
                currentStatus === status 
                  ? `${colors[status]} text-gray-900` 
                  : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
              }`}
            >
              {formatStatusName(status)}
            </button>
          ))}
        </div>
        
        <div className="mt-4 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-300 hover:text-white"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}